import { render, staticRenderFns } from "./AliasDialog.vue?vue&type=template&id=941626ec&"
import script from "./AliasDialog.vue?vue&type=script&lang=ts&"
export * from "./AliasDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports